







import { Component, Vue, Prop } from 'vue-property-decorator';

import { Event } from '../models/event';
import EventInfoCoreDetails from './EventInfoCoreDetails.vue';

@Component({
  components: {
    EventInfoCoreDetails,
  },
})
export default class StepConfirmationComponent extends Vue {
  @Prop({ required: true })
  private event!: Event;
}
